export const GET_BRANDS_SUCCESS = "GET_BRANDS_SUCCESS";
export const GET_BRAND_SUCCESS = "GET_BRAND_SUCCESS";
export const GET_MODEL_SUCCESS = "GET_MODEL_SUCCESS";
export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
export const REQUEST_ERROR = "REQUEST_ERROR";
